import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { MediaInterface } from '../../../interfaces'

@Component({
  selector: 'dmmp-card-image-campus',
  templateUrl: './card-image-campus.component.html',
})
export class CardImageCampusComponent {
  @Input() identifier
  @Input() data
  @Output() page = new EventEmitter()
  medias : MediaInterface[] = [
    {style: 'max_650x650', media: '(max-width:650px) AND (min-width:351px)'},
    {style: 'max_325x325', media: '(max-width:350px)'},
  ]
}
